import axios from 'axios';
import {Message, MessageBox, Loading} from 'element-ui';
import router from '../router/index';
import store from '../store/index';

const httpConfig = axios.create({
  timeout: 5 * 60 *1000,// 请求超时时间
  withCredentials: true,
});
var loadinginstace = null

httpConfig.interceptors.request.use(config => {
  loadinginstace = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.3)',
    customClass: "osloading",
    fullscreen: true
  })
  return config;
}, error => {
  loadinginstace.close()
  return Promise.reject(error)
})

httpConfig.interceptors.response.use(
  res => {
    loadinginstace.close()
    if (res.data.code === 1) {//用户信息失效
      router.push('/login')
    } else {

    }
    loadinginstace.close()
    return res;
  },
  error => {
    Message({
      message: error.description,
      type: 'error',
      duration: 5 * 1000,
    });
    loadinginstace.close()
    return Promise.reject(error);
  },
);

export default httpConfig;



// WEBPACK FOOTER //
// ./src/http/http-config.js